<template>
	<section>
		<super />
	</section>
</template>

<script>
import Super from "./Super";

export default {
	name: "Dashboard",
	components: { Super }
};
</script>
